
document.addEventListener('click', function(e){
  var toggle = e.target.closest('[data-mobile-toggle]');
  if(toggle){
    var menu = document.querySelector('[data-mobile-menu]');
    if(menu) menu.hidden = !menu.hidden;
  }
  var thumb = e.target.closest('[data-gallery-src]');
  if(thumb){
    var main = document.querySelector('[data-gallery-main]');
    if(main) main.src = thumb.getAttribute('data-gallery-src');
  }
});
